import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'hooks';

import { ClientHoldPeriod } from '~weekly-planner/lib/common';

import ModalCard from '~components/ModalCard';
import { DataRow, TableView, useTableViewState } from '~components/table-view';

import columns from '~weekly-planner/forms/info-modal/onHold/list';

import { selectOnHold } from '~weekly-planner/selectors/appointments';

const HoldPeriods: React.FC = () => {
  const clientHoldPeriods = useAppSelector(selectOnHold);

  const { data, setData } = useTableViewState<DataRow<ClientHoldPeriod>>(
    clientHoldPeriods as DataRow<ClientHoldPeriod>[],
  );

  if (!clientHoldPeriods || !clientHoldPeriods.length) {
    return <p>No on hold periods.</p>;
  }

  const [isOnHoldOpen, setIsOnHoldOpen] = useState(true);

  useEffect(() => {
    if (isOnHoldOpen) setData(clientHoldPeriods as DataRow<ClientHoldPeriod>[]);
  }, [isOnHoldOpen]);

  return (
    <div className="container p-4">
      {clientHoldPeriods.length > 0 && (
        <ModalCard
          header="Clients On Hold"
          headerClassName="bg-info"
          isOpen={isOnHoldOpen}
          setIsOpen={setIsOnHoldOpen}
          className="mb-4"
          allowOpen={true}
          allowHeaderOpen={true}
        >
          <TableView id="on-hold-appointments" data={data} columns={columns} emptyMessage="No clients on hold." />
        </ModalCard>
      )}
    </div>
  );
};

export default HoldPeriods;
